/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { IconButton } from '@mui/material';
import SyncSharpIcon from '@mui/icons-material/SyncSharp';
import QSTooltip from '../../../../../shared/components/molecules/tooltip';
import { useEffect, useState } from 'react';
import { RealtimeSearchCountResolution } from '../../typings';

interface RefreshChatCountIconProps {
  disabled?: boolean;
  onRefresh: () => void;
  resolution: RealtimeSearchCountResolution | null;
}

const RefreshChatCountIcon = ({ disabled, onRefresh, resolution }: RefreshChatCountIconProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (resolution === RealtimeSearchCountResolution.LOW) {
      const timer = setTimeout(() => {
        setShowTooltip(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [resolution]);

  if (resolution !== RealtimeSearchCountResolution.LOW) {
    return null;
  }

  return (
    <QSTooltip title="Refresh Chat Count" placement="top" open={showTooltip} onClose={() => setShowTooltip(false)}>
      <IconButton<'div'> disabled={disabled} onClick={onRefresh} component="div">
        <SyncSharpIcon
          css={css`
            fill: #3f906d;
            height: 18px;
            min-height: 18px;
            max-height: 18px;
            width: 18px;
            min-width: 18px;
            max-width: 18px;
            transform: rotate(90deg);
          `}
          strokeWidth={5}
        />
      </IconButton>
    </QSTooltip>
  );
};

export default RefreshChatCountIcon;
